// Từ điển nhãn thẻ của màn Ca lễ tân.
//
// Tách khỏi component vì bài hướng dẫn gọi tên thẻ theo đúng chữ trên màn; gõ
// chuỗi ở hai nơi thì đổi một nơi là bài chỉ tới thẻ không còn tồn tại, im
// lặng. Khoá chính là `value` của `TabsTrigger`, nên hộp hướng dẫn mở thẳng
// được vào thẻ người đọc đang đứng.
//
// Nhãn "Duyệt" trên màn còn kèm số ca đang chờ trong ngoặc; ở đây giữ phần
// chữ, phần đếm là dữ liệu chạy theo tuần nên không thuộc từ điển nhãn.

export const LETAN_SHIFT_TAB_LABEL = {
  register: "Đăng ký",
  approve: "Duyệt",
  payroll: "Lương ca",
} as const;

export type LetanShiftTabKey = keyof typeof LETAN_SHIFT_TAB_LABEL;
